import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../custom-services/ApiService';
import { MultiApiService } from '../custom-services/multi-api.service';
import { environment } from '../../environments/environment';
import { AuthRequestDTO } from '../model/dto/auth-util/auth-request-dto';
import { ReturnViewMode } from './return-view.types';

@Injectable({
  providedIn: 'root'
})
export class ReturnViewService {

  constructor(
    private apiService: ApiService,
    private multiApiService: MultiApiService
  ) { }

  getReturnViewData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/return_view_data'
    );
  }

  checkReturnView(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/check-return-view'
    );
  }

  getSubmissionStatus(): Observable<any> {
    return this.multiApiService.getSubmissionIncludingDacon();
  }

  sendTrpOtp(): Observable<any> {
    return this.apiService.post(
      environment.taxpayer_base_url + '/filingservice/v3/api/trp/send-otp/return-submisison',
      new AuthRequestDTO()
    );
  }

  verifyTrpOtp(otp: string): Observable<any> {
    const request = new AuthRequestDTO();
    request.otp = Number(otp);

    return this.apiService.post(
      environment.taxpayer_base_url + '/filingservice/v3/api/trp/verify-otp/return-submission',
      request
    );
  }

  submitReturn(tinNo: string, assessmentYear: string): Observable<any> {
    return this.apiService.post(
      environment.taxpayer_base_url + '/filingservice/v3/api/save_submission',
      {
        assessmentYear,
        submissionStatus: true,
        returnSubmissionType: 'ONLINE',
        tinNo,
        returnType: 'TAXPAYER'
      }
    );
  }

  getCurrentAssessmentYear(): string {
    return localStorage.getItem('CURRENT_ASSESSMENT_YEAR') || '2022-2023';
  }

  shouldLoadReturnData(mode: ReturnViewMode, submissionStatus: string | null | undefined): boolean {
    if (mode === 'post-sub') {
      return submissionStatus !== 'ONLINE';
    }

    return submissionStatus === 'ONLINE';
  }

  getIncomeFormEmploymentData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/income-head/salaries'
    );
  }

  getIncomeFormFinancialAssetsData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/get-interest-on-security-data'
    );
  }

  getIncomeFormRentData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/get-house-property-data'
    );
  }

  getIncomeFormAgricultureData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/get-agriculture-data'
    );
  }

  getIncomeFormBusinessData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/income-head/business'
    );
  }

  getIncomeFormCapitalGainData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/get_capital_gains'
    );
  }

  getIncomeFormOtherSourcesData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/get-ifos-data'
    );
  }

  getIncomeFormFirmEtcData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/income-head/firm-etc'
    );
  }

  getIncomeFormTaxExemptedIncomeData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/get-tax-exempted-income'
    );
  }

  getIncomeFormVoluntaryDisclosureData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/undisclosed-income/get-all'
    );
  }

  getIncomeFormVoluntaryDisclosureHeads(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/undisclosed-income/get-income-heads'
    );
  }

  getRebateDetailsData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/user-panel/rebate'
    );
  }

  getReturnDetailsData(): Observable<any> {
    return this.apiService.get(
      environment.taxpayer_base_url + '/filingservice/v3/api/detail-return/get'
    );
  }
}
